export { MaintenanceStatusPage as default } from './Wrapper'
